var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container container_40" }, [
    _c(
      "div",
      { staticClass: "container__no-data" },
      [
        _c("md-icon", { staticClass: "md-size-4x" }, [
          _vm._v(_vm._s(_vm.icon))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "text_large" }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("div", { staticClass: "text_description text_margin text_medium" }, [
          _vm._v(_vm._s(_vm.descr))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-086533ea", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-086533ea","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/common/NotAvailableCard.vue
// module id = EUyb
// module chunks = 1